// 默认布局使用的多语言

export default {
  "zh-CN": {
    basicLayout: {
      title: "供应商申请合作",
      btn: ["上一步", "下一步", "提交"]
    }
  },
  "en-US": {
    basicLayout: {
      title: "Supplier application for cooperation",
      btn: ["Back", "Next", "submit"]
    }
  },
  "es-ES": {
    // 需要更改
    basicLayout: {
      title: "供应商申请合作",
      btn: ["atrás", "Siguiente", "presentar"]
    }
  },
  "fa-FR": {
    basicLayout: {
      title: "供应商申请合作",
      btn: ["Précédent", "Suivant", "Soumettre"]
    }
  },
  "els-RU": {
    basicLayout: {
      title: "供应商申请合作",
      btn: ["Предыдущий", "Следующий", "представ"]
    }
  },
  "alb-AR": {
    basicLayout: {
      title: "供应商申请合作",
      btn: ["السابق", "الخطوة التالية", "تقديم"]
    }
  }
};
